<template>
  <div class="project-approval-page p-0">
    <!-- 筛选区域 -->
    <div class="filter-section">
      <div>
        <el-form :model="searchFilter" ref="projectForm" label-position="left" class="projectForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称" :label-width="labelWidth">
                <el-input class="text-input" v-model="searchFilter.projectName" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目分类" :label-width="labelWidth">
                <el-select v-model="searchFilter.projectClassId" class="seletc-size-input-1" placeholder="请选择">
                  <el-option v-for="item in projectTypeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="审批级别" :label-width="labelWidth">
                <el-select v-model="searchFilter.approvalLevelId" class="seletc-size-input-1" placeholder="请选择">
                  <el-option v-for="item in approvalLevelList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="立项批复时间" :label-width="labelWidth">
                <el-date-picker size="large" value-format="yyyy-MM-dd" v-model="searchFilter.approvalDateMin"
                  type="date" placeholder="选择开始时间"></el-date-picker> -
                <el-date-picker v-model="searchFilter.approvalDateMax" value-format="yyyy-MM-dd" type="date"
                  placeholder="选择结束时间"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="总投资" :label-width="labelWidth">
                <el-input class="num-size-input" v-model="searchFilter.totalInvestmentMin" placeholder=""></el-input>-
                <el-input class="num-size-input" v-model="searchFilter.totalInvestmentMax"
                  placeholder=""></el-input>（万元）
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="总面积" :label-width="labelWidth">
                <el-input class="num-size-input" v-model="searchFilter.totalAreaMin" placeholder=""></el-input>-
                <el-input class="num-size-input" v-model="searchFilter.totalAreaMax" placeholder=""></el-input>（平方米）
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="建设性质" :label-width="labelWidth">
                <el-select v-model="searchFilter.natureId" class="seletc-size-input-1" placeholder="请选择">
                  <el-option v-for="item in natureTypeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用途" :label-width="labelWidth">
                <el-select v-model="searchFilter.purposeId" class="seletc-size-input-1" placeholder="请选择">
                  <el-option v-for="item in purposeTypeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="计划开工日期" :label-width="labelWidth">
                <el-date-picker size="large" value-format="yyyy-MM-dd" v-model="searchFilter.planBeginDateMin"
                  type="date" placeholder="选择开始时间"></el-date-picker> -
                <el-date-picker v-model="searchFilter.planBeginDateMax" value-format="yyyy-MM-dd" type="date"
                  placeholder="选择结束时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数据等级" :label-width="labelWidth">
                <el-select v-model="searchFilter.dataLevel" class="seletc-size-input-1" placeholder="请选择">
                  <el-option v-for="item in dataLevelList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="地区" :label-width="labelWidth">
                <el-select v-model="searchFilter.province" class="seletc-size-input"
                  @change="areaChange($event, 'province')">
                  <el-option v-for="item in provinceList" :key="item.areaId" :label="item.areaName"
                    :value="item.areaId">
                  </el-option>
                </el-select>
                <el-select v-model="searchFilter.city" class="seletc-size-input" @change="areaChange($event, 'city')">
                  <el-option v-for="item in cityList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
                  </el-option>
                </el-select>
                <el-select v-model="searchFilter.county" class="seletc-size-input"
                  @change="areaChange($event, 'county')">
                  <el-option v-for="item in countyList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn oh mr-8 mb-2">
          <div class="fr">
            <el-button icon="el-icon-search" type="primary" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 数据表格区域 -->
    <div class="table-section">
      <div class="table-header">
        <div class="table-title">
          <i class="el-icon-document-checked"></i>
          <span>建设项目</span>
          <el-tag size="small" type="info">{{ total }} 条</el-tag>
        </div>
      </div>

      <el-table :data="tableData" stripe border v-loading="loading" class="data-table"
        :header-cell-style="headerCellStyle">

        <el-table-column prop="index" width="60" align="center" label="序号">
          <template slot-scope="{ $index }">
            {{ $index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>

        <el-table-column prop="projectName" label="项目代码" min-width="150">
          <template slot-scope="{ row }">
            <span class="code-text">{{ row.projectCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="单位名称" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false"
              @click="handlerLinkLocal('/constructionProject/detail?id=' + row.id+'&type=1')">
              {{ row.projectName }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column prop="projectClass" label="项目类型" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="code-text">{{ row.projectClass }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="地区" width="180" align="center">
          <template slot-scope="{ row }">
            {{ row.province }}{{ row.city }}
          </template>
        </el-table-column>
        <el-table-column prop="nature" label="建设性质" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row.nature || '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="nature" label="数据等级" width="80" align="center">
          <template slot-scope="{ row }">
            {{ row.nature || '-' }}
          </template>
        </el-table-column>

        <el-table-column prop="approvalLevel" label="审批级别" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.approvalLevel }}
          </template>
        </el-table-column>
        <el-table-column prop="totalInvestment" label="总投资(万元)" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.totalInvestment == 0 ? '-' : row.totalArea }}
          </template>
        </el-table-column>
        <el-table-column prop="totalArea" label="总面积(平方米)" width="140" align="center">
          <template slot-scope="{ row }">
            {{ row.totalArea == 0 ? '-' : row.totalArea }}
          </template>
        </el-table-column>
        <el-table-column prop="planBeginDate" label="计划开工时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.planBeginDate }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small"
              @click="handlerLinkLocal('/constructionProject/detail?id=' + row.id+'&type=1')">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
          background />
      </div>
    </div>
  </div>
</template>

<script>
import { dataInJs } from '@/utils/city.js';
export default {
  name: 'constructionProject',
  components: {
  },
  data() {
    return {
      provinceList: dataInJs(),
      cityList: [],
      countyList: [],
      projectTypeList: [],
      approvalLevelList: [],
      natureTypeList: [],
      purposeTypeList: [],
      dataLevelList: [],
      pageType: 1,
      // 筛选条件
      labelWidth: '150px',
      searchFilter: {
        projectName: '',
        projectClassId: '',
        approvalLevelId: '',
        approvalDateMin: '',
        approvalDateMax: '',
        totalInvestmentMin: '',
        totalInvestmentMax: '',
        totalAreaMin: '',
        totalAreaMax: '',
        natureId: '',
        purposeId: '',
        planBeginDateMin: '',
        planBeginDateMax: '',
        dataLevel: '',
        province: 44,
        city: '',
        county: '',
      },

      // 表格数据
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0

    }
  },
  // props: {
  //   pageData:{
  //     type: Object,
  //     default:()=>{}
  //   }
  // },

  mounted() {
    this.getParameter();
    this.fetchData();
  },

  methods: {
    hanlderPageType(list) {
      this.pageType = list.value;
    },
    //获取参数
    getParameter() {
      let ajaxUrl = this.$api.common.constructionProject.Parameter();
      this.$axios.get(ajaxUrl).then((res) => {
        console.log('类型', res);
        this.projectTypeList = res.data.projectClass;
        this.approvalLevelList = res.data.approvalLevel;
        this.natureTypeList = res.data.nature;
        this.purposeTypeList = res.data.purpose;
        this.dataLevelList = res.data.dataLevel;
      }).catch((err) => {
      })
    },
    // 表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#2c5282',
        color: '#fff',
        fontWeight: 600,
        fontSize: '14px'
      }
    },
    //省市区切换
    areaChange(val, type) {
      if (type === 'province') {
        this.cityList = this.provinceList.filter(item => item.areaId === val)[0].children;
        this.countyList = [];
        this.searchFilter.city = '';
        this.searchFilter.county = '';
      } else if (type === 'city') {
        this.countyList = this.cityList.filter(item => item.areaId === val)[0].children;
      } else if (type === 'county') {
        // 选择县区后不需要做额外操作
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchData()
    },
    // 获取数据
    fetchData() {
      this.loading = true;
      let ajaxUrl = this.$api.common.constructionProject.List();
      let params = {
        page: this.currentPage,
        ...this.searchFilter
      }
      this.$axios.get(ajaxUrl, { params }).then((res) => {
        console.log('建设项目', res);
        this.tableData = res.list;
        this.total = res.totalRecord;
        this.loading = false;
      }).catch((err) => {
        this.loading = false
      })
    },

    // 重置
    handleReset() {
      this.searchFilter = {
        projectName: '',
        projectClassId: '',
        approvalLevelId: '',
        approvalDateMin: '',
        approvalDateMax: '',
        totalInvestmentMin: '',
        totalInvestmentMax: '',
        totalAreaMin: '',
        totalAreaMax: '',
        natureId: '',
        purposeId: '',
        planBeginDateMin: '',
        planBeginDateMax: '',
        dataLevel: '',
        province: '',
        city: '',
        county: '',
      }
      this.currentPage = 1
      this.fetchData();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    }

  }
}
</script>

<style lang="less" scoped>
.project-approval-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);

  // 页面头部
  .page-header {
    margin-bottom: 20px;
    padding: 0 5px;

    .header-left {
      display: flex;
      align-items: center;

      i {
        font-size: 24px;
        color: #2c5282;
        margin-right: 10px;
      }

      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #1a365d;
        margin: 0;
      }
    }
  }

  // 横向时间线分类区域
  .timeline-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
    overflow: hidden;

    .timeline-container {
      display: flex;
      width: 100%;
    }

    .timeline-block {
      display: flex;
      flex-direction: column;
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      min-height: 90px;

      &:last-child {
        border-right: none;
      }

      // 大分类标题
      .main-category-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        justify-content: space-around;

        .main-name {
          font-size: 14px;
          font-weight: 600;
          color: #1a365d;
        }

        .main-count {
          font-size: 12px;
          color: #4a5568;
          background: rgba(255, 255, 255, 0.7);
          padding: 2px 8px;
          border-radius: 10px;
          min-width: 24px;
          text-align: center;
        }
      }

      // 二级分类容器
      .sub-categories {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 12px 16px;
        flex: 1;
        align-items: center;
        justify-content: space-around;

        // 二级分类胶囊
        .sub-category-pill {
          padding: 6px 14px;
          border-radius: 16px;
          font-size: 13px;
          color: #4a5568;
          background: #005aa817;
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.25s ease;
          white-space: nowrap;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

          &:hover {
            border-color: #2c5282;
            color: #2c5282;
            transform: translateY(-1px);
            box-shadow: 0 2px 6px rgba(44, 82, 130, 0.15);
          }

          // 选中状态 - 深蓝填充
          &.active {
            background: #2c5282 !important;
            border-color: #2c5282 !important;
            color: #fff !important;
            box-shadow: 0 2px 8px rgba(44, 82, 130, 0.3);
            font-weight: 500;
          }
        }
      }
    }
  }

  // 筛选区域
  .filter-section {
    background: #fff;
    border-radius: 0 0 8px 8px;;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .filter-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;
    }

    .filter-item {
      display: flex;
      align-items: center;

      .filter-label {
        font-size: 14px;
        color: #4a5568;
        margin-right: 10px;
        font-weight: 500;
        white-space: nowrap;
      }

      &.search-item {
        flex: 1;
        max-width: 300px;
      }
    }

    .date-picker {
      width: 280px;
    }

    .location-picker {
      width: 200px;
    }

    .search-input {
      width: 100%;
    }

    .filter-actions {
      margin-left: auto;

      .el-button {
        margin-left: 10px;
      }
    }
  }

  // 表格区域
  .table-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .table-title {
        display: flex;
        align-items: center;

        i {
          font-size: 18px;
          color: #2c5282;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          font-weight: 600;
          color: #1a365d;
          margin-right: 10px;
        }

        .el-tag {
          font-weight: normal;
        }
      }
    }

    // 表格样式
    .data-table {
      border-radius: 6px;
      overflow: hidden;
      font-size: 16px;

      ::v-deep .el-table__header-wrapper {
        th {
          background-color: #2c5282 !important;
        }
      }

      .code-text {
        color: #4a5568;
        font-size: 16px;
        letter-spacing: 0.5px;
      }

      .status-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 6px;

        &.active {
          background: #48bb78;
          box-shadow: 0 0 0 2px rgba(72, 187, 120, 0.2);
        }

        &.inactive {
          background: #cbd5e0;
        }
      }

      .date-icon {
        color: #2c5282;
        margin-right: 4px;
      }

      ::v-deep .el-link {
        font-weight: 500;
      }
    }

    // 分页
    .pagination-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}

// 按钮主题色覆盖
::v-deep .el-button--primary {
  background: #2c5282;
  border-color: #2c5282;

  &:hover,
  &:focus {
    background: #1a365d;
    border-color: #1a365d;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2c5282;
}

::v-deep .el-link.el-link--primary {
  color: #2c5282;

  &:hover {
    color: #1a365d;
  }
}
</style>